/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { PaginatedCategoryAdmin } from './PaginatedCategoryAdmin'
import {
  PaginatedCategoryAdminFromJSON,
  PaginatedCategoryAdminFromJSONTyped,
  PaginatedCategoryAdminToJSON,
} from './PaginatedCategoryAdmin'

/**
 *
 * @export
 * @interface EnvelopedCategoryListCategoryAdmin
 */
export interface EnvelopedCategoryListCategoryAdmin {
  /**
   *
   * @type {PaginatedCategoryAdmin}
   * @memberof EnvelopedCategoryListCategoryAdmin
   */
  body: PaginatedCategoryAdmin
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedCategoryListCategoryAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedCategoryListCategoryAdmin interface.
 */
export function instanceOfEnvelopedCategoryListCategoryAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedCategoryListCategoryAdminFromJSON(
  json: any,
): EnvelopedCategoryListCategoryAdmin {
  return EnvelopedCategoryListCategoryAdminFromJSONTyped(json, false)
}

export function EnvelopedCategoryListCategoryAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedCategoryListCategoryAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: PaginatedCategoryAdminFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedCategoryListCategoryAdminToJSON(
  value?: EnvelopedCategoryListCategoryAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: PaginatedCategoryAdminToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
